import { render, staticRenderFns } from "./viewSubPartnerLink.vue?vue&type=template&id=63dfb786"
import script from "./viewSubPartnerLink.vue?vue&type=script&lang=js"
export * from "./viewSubPartnerLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports